import { useState } from "react";
import { motion } from "framer-motion";

export default function ProductPhoto({ photos, alt, className = "aspect-[4/5] w-full object-cover", testidPrefix, sold = false }) {
  const list = (photos || []).filter(Boolean);
  const [idx, setIdx] = useState(0);
  const safe = Math.min(idx, Math.max(list.length - 1, 0));
  const multi = list.length > 1;

  if (list.length === 0) {
    return (
      <div
        className={`flex flex-col items-center justify-center gap-3 bg-[#F4F2ED] ${className}`}
        data-testid={`${testidPrefix}-photos`}
      >
        {sold ? (
          <span
            className="-rotate-6 border-2 border-zinc-700 bg-white px-3 py-1.5 font-mono text-xs font-semibold uppercase tracking-[0.3em] text-zinc-700"
          >
            Vendu
          </span>
        ) : (
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-zinc-400">
            Photo à venir
          </span>
        )}
      </div>
    );
  }

  return (
    <div className="relative overflow-hidden" data-testid={`${testidPrefix}-photos`}>
      <motion.img
        key={safe}
        src={list[safe] || ""}
        alt={alt}
        loading="lazy"
        title={multi ? "Cliquer pour voir la photo suivante" : undefined}
        onClick={multi ? () => setIdx((i) => (i + 1) % list.length) : undefined}
        className={`${className} ${multi ? "cursor-pointer" : ""} ${sold ? "opacity-60 grayscale" : ""}`}
        initial={{ opacity: 0.3 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4 }}
      />
      {sold && (
        <div className="absolute inset-0 flex items-center justify-center bg-black/40">
          <span
            data-testid={`${testidPrefix}-sold-overlay`}
            className="-rotate-6 border-2 border-white bg-black/75 px-4 py-2 font-mono text-base font-semibold uppercase tracking-[0.3em] text-white"
          >
            Vendu
          </span>
        </div>
      )}
      {multi && (
        <>
          <span className="absolute right-3 top-3 bg-black/60 px-2 py-0.5 font-mono text-[10px] text-white">
            {safe + 1}/{list.length}
          </span>
          <div className="absolute bottom-3 left-1/2 flex -translate-x-1/2 gap-1.5">
            {list.map((_, i) => (
              <span
                key={i}
                className={`h-1.5 w-1.5 rounded-full ${i === safe ? "bg-white" : "bg-white/50"}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
